import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Divider,
} from "@material-ui/core";
import { styles } from "./styles";

function Transition(props) {
  return <Slide direction="left" {...props} />;
}

const UnbindDialog = ({ open, onClose: handleClose, onUnbind }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      style={styles.dialog}
      maxWidth="xs"
      onClose={handleClose}
      keepMounted
    >
      <DialogTitle>Atenção!</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText style={styles.dialogContentText}>
          Ao continuar com a remoção, o motorista atual perde automaticamente o
          acesso ao dispositivo. Deseja prosseguir com a remoção?
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions style={styles.dialogActions}>
        <Button
          style={styles.proceedButton}
          variant="contained"
          autoFocus
          color="primary"
          onClick={onUnbind}
        >
          Prosseguir
        </Button>
        <Button
          type="submit"
          autoFocus
          style={styles.cancelButton}
          variant="outlined"
          onClick={handleClose}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UnbindDialog;
